import { put2 } from "@/shared/axios";
import useBranchId from "@/shared/hooks/useBranchId";
import { QrSettings } from "@/shared/utils/interfaces";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

const useQrSettingsPut = () => {
  const branch = useBranchId();
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  const mutation = useMutation<any, QrSettings, any>({
    mutationFn: (data: QrSettings) => {
      return put2(
        `/internal/secure/pos/v1/table/live/order/tracker/settings`,
        data
      );
    },
    onSuccess: () => {
      queryClient.refetchQueries({
        queryKey: ["qrSettings", branch],
        exact: true,
      });
      toast.success(t("success.update"));
    },
  });

  return mutation;
};

export default useQrSettingsPut;
